import * as Sentry from '@sentry/react';
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import './styles/document-content.css'

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  tunnel: "/sentry-tunnel",
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  tracesSampleRate: import.meta.env.PROD ? 0.2 : 1.0,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  environment: import.meta.env.MODE,
  enabled: !!import.meta.env.VITE_SENTRY_DSN,
});

createRoot(document.getElementById("root")!).render(<App />);
